// Shared mailbox between the in-canvas DetectionScanner (writes projected
// boxes at ~10Hz from useFrame) and the DOM DetectionOverlay (reads on its
// own rAF and mutates styles directly). A module ref instead of the store on
// purpose: box positions change every scan and routing them through React
// would re-render an overlay ~10x a second for pure style updates.

export const detection = {
  boxes: [],   // { id, word, x, y, w, h, dist, conf, gold }
  version: 0,
}
